module.exports = __webpack_public_path__ + "80ea94e8f628c594155850f12ef27087.svg";